import React, { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import Container from "../../shared/Container";
import PrimaryButton from "../../shared/PrimaryButton";
import BoxBorder from "../../shared/BoxBorder";
import SuccessMessage from "../../shared/SuccessMessage";
import {
   validateRequired,
   validateForm,
   validateSubdomain,
} from "../../../util/shared/validation";
import { addSubdomain, queryClient } from "../../../util/admin/httpAdmin";
import rocketIconWhite from "../../../assets/admin/icons/rocket-white.svg";
import LoadingIndicatorButton from "../../shared/LoadingIndicatorButton";

const AddSubdomainFormAdmin = ({ onSuccessAdd }) => {
   const [successMessage, setSuccessMessage] = useState("");
   const [subdomain, setSubdomain] = useState("");
   const [isFocused, setIsFocused] = useState(false);
   const [errorMessage, setErrorMessage] = useState("");
   const subdomainPreview = subdomain
      ? `resto-online.be/${subdomain}`
      : "resto-online.be";

   const { mutate, isPending, isError, error } = useMutation({
      mutationFn: addSubdomain,
      onSuccess: (data) => {
         setSuccessMessage(
            `Webshop succesvol gelanceerd op ${subdomainPreview}!`
         );
         setTimeout(() => {
            queryClient.invalidateQueries(["accountSettings"]);
            setSuccessMessage("");
         }, 500);
      },
      onError: () => {
         console.error("Fout bij het lanceren van de webshop", error);
      },
   });

   const handleFormSubmit = (e) => {
      e.preventDefault();

      const validationResult = validateForm(subdomain, [
         validateRequired,
         validateSubdomain,
      ]);
      if (validationResult) {
         setErrorMessage(validationResult);
         return;
      }

      setErrorMessage("");
      mutate({ subdomain });
   };

   const handleBlur = () => {
      setIsFocused(false);
      if (subdomain) {
         const validationResult = validateForm(subdomain, [
            validateRequired,
            validateSubdomain,
         ]);
         setErrorMessage(validationResult || "");
      }
   };

   const handleFocus = () => {
      setIsFocused(true);
   };

   const handleChange = (e) => {
      const value = e.target.value;
      setSubdomain(value);
      if (isFocused) {
         const validationResult = validateForm(value, [
            validateRequired,
            validateSubdomain,
         ]);
         setErrorMessage(validationResult || "");
      }
   };

   return (
      <section>
         <Container>
            {successMessage ? (
               <SuccessMessage title="Succes!" description={successMessage} />
            ) : (
               <BoxBorder extraClasses="mxw-1000 m-a g-20">
                  <h2>Webshop Lanceren</h2>
                  <form className="g-20">
                     <div className="form-group g-5">
                        <label htmlFor="subdomainInput">
                           Webshoplink ({subdomainPreview})
                        </label>
                        <input
                           id="subdomainInput"
                           type="text"
                           value={subdomain}
                           onChange={handleChange}
                           onBlur={handleBlur}
                           onFocus={handleFocus}
                           placeholder="Voer een unieke subdomein in"
                           className="form-control"
                        />

                        {errorMessage && (
                           <div className="c-r">{errorMessage}</div>
                        )}
                     </div>
                     {isError && (
                        <div className="c-r">
                           {error?.message ||
                              "Er is een fout opgetreden bij het lanceren."}
                        </div>
                     )}
                     <div>
                        <PrimaryButton
                           onClick={handleFormSubmit}
                           disabled={isPending}
                        >
                           <div className="g-15-1fr">
                              <img src={rocketIconWhite} alt="lanceren"></img>
                              <span className="flex-0-5">
                                 Webshop lanceren
                                 {isPending && (
                                    <LoadingIndicatorButton></LoadingIndicatorButton>
                                 )}
                              </span>
                           </div>
                        </PrimaryButton>
                     </div>
                  </form>
               </BoxBorder>
            )}
         </Container>
      </section>
   );
};

export default AddSubdomainFormAdmin;
